var FreeGift = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.settings = JSON.parse(document.querySelector(`[data-gift-settings]`).innerHTML);
    this.testThreshold();
    //this.giftInCart = document.querySelector('[data-gift-one]');
    this.giftTwoInCart = document.querySelector('[data-gift-two]');
  }

  testThreshold(){
    fetch(`/cart.js`)
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        console.log(cart)
        this.threshold = this.settings.threshold;
        cart.items.forEach(item => {
          if(item.variant_id === this.settings.giftId) {
            this.giftInCart = true;
            this.threshold = this.threshold + item.final_price;
            return;
          } else {
            this.giftInCart = false;
          }
        });
        this.cartTotal = cart.total_price;
        if(this.settings.thresholdTwo) {
          this.updateTwoGifts(this.cartTotal);
        } else {
          this.updateOneGift(this.cartTotal);
        }
      })
      .catch((error) => {
        console.error;
      }); 
  }

  updateOneGift(total) {
    console.log(this.giftInCart, this.threshold, total)
    
    if(this.giftInCart) {
      console.log('gift in cart')
      if(total < this.threshold) {
        console.log('remove product')
        let formData = {
          updates: {
            [this.settings.giftId]: 0
          }
        };
        this._updateCart(formData);
      } 
    } else {
      if(total >= this.threshold) {
        let formData = {
          updates: {
            [this.settings.giftId]: 1
          }
        };
        this._updateCart(formData);
      }
    }
  }

  updateTwoGifts(total) {
    if(this.giftInCart && total < this.settings.threshold) {
      let formData = {
        updates: {
          [this.settings.giftId]: 0,
          [this.settings.giftTwoId]: 0,
        }
      };
      this._updateCart(formData);
    }
    
    if(this.cartTotal >= this.settings.threshold && this.cartTotal < this.settings.thresholdTwo){
      let formData = {
        updates: {
          [this.settings.giftId]: 1,
          [this.settings.giftTwoId]: 0,
        }
      };
      this._updateCart(formData);
    }

    if(this.cartTotal >= this.settings.thresholdTwo) {
      let formData = {
        updates: {
          [this.settings.giftId]: 1,
          [this.settings.giftTwoId]: 0,
        }
      };
      this._updateCart(formData);
    }
  }

  async updateElement() {
    const res = await fetch('/?section_id=cart-drawer');
    const section = await res.text();
    const cartDrawer = document.createElement('div');
    cartDrawer.innerHTML = section;

    const updatedGWP = cartDrawer.querySelector(`multi-tier-gift`);
    const currentGWP = document.querySelector(`multi-tier-gift`);
    if (currentGWP && updatedGWP) {
      currentGWP.innerHTML = updatedGWP.innerHTML;
    } 
  }

  async _updateCart(formData) {
    return new Promise((resolve, reject) => {
      fetch(`/cart/update.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then((response) => {
        const updatedCart = response;
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: updatedCart
          }
        }));
        this.cartDrawer = this.closest('cart-drawer');
        if(this.cartDrawer) {
          this.cartDrawer._updateCart();
          this.cartDrawer._updateCartCount();
        }
      })
      .catch((e) => {
          console.error(e);
          reject(e);
      })
      .finally((response) => {
        this.updateElement();
      })
    });
  }
};
window.customElements.define('multi-tier-gift', FreeGift);
